import { PJAxios, sendLogin, useAppInfo, useLanguage, useParams, usePJStore, useUserInfo } from '@jaf/jaf-react-core';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { InputNumber } from 'primereact/inputnumber';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import FormRow from '../Common/FormRow';

import { usePJSalto } from '@jaf/jaf-react-core'
import { PJButton, PJContent, PJHeader, PJPage } from '@it-polimi/pj-react-ui';
import { useStore } from '../../../../store/store';

function DottorandiForm(props) {

    const toast = useRef(null);
    const getText = usePJStore((state) => state.i18n_getText)
    const params = useParams();

    const isLogged = useUserInfo() != null;
    const userInfo = useUserInfo();
    const { storage } = usePJStore((state) => state.storage)
    const language = useLanguage();
    const appInfo = useAppInfo();

    const allegatoRef = useRef(null);


    const [selectedQueue, setSelectedQueue] = useState(null)

    const [selectedNodeId, setSelectedNodeId] = useState(params != null ? params.selectedNodeId : "");


    const [ticketSent, setTicketSent] = useState(false)

    const [loading, setLoading] = useState(false)

    const [oggetto, setOggetto] = useState("")
    const [testo, setTesto] = useState("")

    const [nome, setNome] = useState("")
    const [cognome, setCognome] = useState("")
    const [email, setEmail] = useState("")
    const [typedEmail, setTypedEmail] = useState("")

    const [codice_persona, setCodice_persona] = useState("")
    const [allegato, setAllegato] = useState([])

    const [dynamicFields, setDynamicFields] = useState([])

    const [dests, setDests] = useState(useStore.getState().dests != null ? useStore.getState().dests : [])

    useEffect(() => {
        console.log("dests from store: ", useStore.getState().dests)
        setSelectedQueue(dests.length === 1 ? dests[0] : null)
    }, [dests]);

    useEffect(() => {
        if (useStore.getState().datiDottorando != null) {
            let _dynamicFields = []
            _dynamicFields.push({ code: "DottNomeCorso", value: useStore.getState().datiDottorando.nomeCorso })
            _dynamicFields.push({ code: "DottNumCiclo", value: useStore.getState().datiDottorando.numCiclo })
            _dynamicFields.push({ code: "DottDipAfferenzaAmministrativaCOD", value: useStore.getState().datiDottorando.codDipAfferenzaAmministrativa })
            _dynamicFields.push({ code: "DottDipAfferenzaAmministrativa", value: useStore.getState().datiDottorando.dipAfferenzaAmministrativa })
            _dynamicFields.push({ code: "DottDipAfferenzaScientificaCOD", value: useStore.getState().datiDottorando.codDipAfferenzaScientifica })
            _dynamicFields.push({ code: "DottDipAfferenzaScientifica", value: useStore.getState().datiDottorando.dipAfferenzaScientifica })
            console.log("setting dynamic fields: ", _dynamicFields)
            setDynamicFields(_dynamicFields)
        }
    }, []);

    const allegatoBase64Uploader = async (event) => {

        const file = event.files[0];

        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onloadend = function (e) {
            if (file.size < 2500000) {
                let b64payload = btoa(e.target.result);
                const content = e.target.result;
                let _allegato = allegato.splice(0)
                _allegato.push({ data: b64payload, name: file.name, size: file.size, type: file.type })
                setAllegato(_allegato)

                allegatoRef.current.clear();
            } else {
                toast.current.show({ severity: 'error', life: 10000, summary: getText("INFORMAZIONE"), detail: getText("FILE_BIGGER_THAN_ALLOWED") });
                allegatoRef.current.clear();
            }

        };
    };

    useEffect(() => {

        console.log("email changed: ", email)
    }, [email]);


    useEffect(() => {

        if (params.categoria) {
            console.log("set categoria from params", params.categoria)
            setCategoria(params.categoria)
        }

        if (isLogged) {
            setNome(userInfo.nome)
            setCognome(userInfo.cognome)
            setEmail(userInfo.email)
            setCodice_persona(userInfo.codicePersona)
        } else {
            setNome(params.nome)
            setCognome(params.cognome)
            setEmail(params.email)
            setCodice_persona(params.codicePersona)
        }
    }, [isLogged, params]);

    const progettoPreliminareFileUploadRef = useRef(null);

    const progettoPreliminareBase64Uploader = async (event) => {
        // convert file to base64 encoded
        const file = event.files[0];

        const reader = new FileReader();
        reader.readAsBinaryString(file);


        reader.onloadend = function (e) {
            if (file.size < 2500000) {

                let b64payload = btoa(e.target.result);
                setProgettoPreliminare({ data: b64payload, name: "PROGETTO_PRELIMINARE_" + file.name, size: file.size, type: file.type })
                progettoPreliminareFileUploadRef.current.clear();
            } else {
                toast.current.show({ severity: 'error', life: 10000, summary: getText("INFORMAZIONE"), detail: getText("FILE_BIGGER_THAN_ALLOWED") });
                progettoPreliminareFileUploadRef.current.clear();
            }
        };
    };

    useEffect(() => {
        console.log("selectedQueue changed: ", selectedQueue)
    }, [selectedQueue]);




    const createNewTicket = () => {
        setTicketSent(false)

    }

    const pickRightQueue = (item, codes, dests) => {
        console.log("pickRightQueue item: ", item, "codes: ", codes)
        let ret = ""
        if(dests.length === 1){
            ret = dests[0].queue
        }
        if (item != null && typeof item.email === 'string') {
            // 1. Splitta la stringa item.email al carattere a capo ('\n')
            const lines = item.email.split('\n');

            if (lines.length === 1) {
                ret = item.email;
            } else {
                codes.forEach(code => {
                    console.log("code: ", code)
                    const foundString = lines.find(line => line.includes(code));
                    console.log("foundString: ", foundString)
                    if (foundString !== undefined) {
                        ret = foundString;
                    }
                });
            }
            // Se ci sono più righe, cerca la riga che contiene il codice
            return ret;
        } else {
            // Ritorna una stringa vuota se item è null o item.email non è una stringa
            return ret;
        }
    }

    const sendTicket = () => {
        let codes = []
        if(useStore.getState().datiDottorando != null){
            codes = [useStore.getState().datiDottorando.kCorsoLa, useStore.getState().datiDottorando.codDipAfferenzaAmministrativa]
        }
        
        const params = {
            nome: nome,
            cognome: cognome,
            email: email != null && email.trim() !== "" ? email : typedEmail,
            codicePersona: codice_persona != null ? codice_persona : null,
            oggetto: oggetto,
            testo: testo,
            queue: pickRightQueue(selectedQueue, codes,dests),
            dynamicFields: dynamicFields != null ? dynamicFields : null,
            allegati: allegato
        }

        console.log("sending ticket with params: ", params)

        var url = '/nuovaRichiesta/sendTicket';
        setLoading(true)
        PJAxios().post(url, params).then((res) => {
            setTicketSent(res.data)
            if (res.data) {
                toast.current.show({ severity: 'success', summary: getText("INFORMAZIONE"), detail: getText("TICKET_CREATED_SUCCESSFULLY") });
            } else {
                toast.current.show({ severity: 'danger', summary: getText("INFORMAZIONE"), detail: getText("ERROR_CREATING_TICKET") });
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    const validEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    const validForm = () => {
        var valid = oggetto.trim() !== "" && testo.trim() !== "" && !ticketSent && validEmail(typedEmail || email) && selectedQueue != null && cognome != null && cognome.trim() !== "" && nome != null && nome.trim() !== "" ;
        return valid;
    }

    const sediList = [
        { name: getText("CITTA_STUDI"), code: 'MI', queue: '[OQ:AGIS::Eventi::Leonardo]' },
        { name: getText("BOVISA"), code: 'BO', queue: '[OQ:AGIS::Eventi::Bovisa]' }
    ];

    const queueTemplate = (option) => {
        if (option == null) {
            return <>&nbsp;</>;
        } else {
            return (
                <div className="country-item">
                    <div>{getText(option.label)}</div>
                </div>
            );
        }
    }


    return (
        <>
            <Toast ref={toast} position="top-right" />
            {loading &&
                <div className="loading-overlay">
                    <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                </div>
            }

            {!loading &&

                <PJPage>
                    <PJHeader></PJHeader>
                    <PJContent>
                        <>
                            {email != null && email.trim() !== "" &&
                                <>
                                    <div className='formgroup-inline col-12'>
                                        <div className='col-2 pj-bg-primary-light'>
                                            {getText("FROM")}
                                        </div>
                                        <div className='col-10'>
                                            {cognome} {nome} ({email})
                                        </div>
                                    </div>
                                </>
                            }
                            { email == undefined &&
                                <>
                                    <div className='formgroup-inline col-12'>
                                        <div className='col-2 pj-bg-primary-light'>
                                            {getText("EMAIL")}
                                        </div>
                                        <div className='col-10'>
                                            <InputText style={{ width: '100%' }} className="width500px p-inputtext-sm block mb-2 " id="email" value={typedEmail} onChange={(e) => setTypedEmail(e.target.value)} />

                                        </div>
                                    </div>
                                    <div className='formgroup-inline col-12'>
                                        <div className='col-2 pj-bg-primary-light'>
                                            {getText("COGNOME")}
                                        </div>
                                        <div className='col-10'>
                                            <InputText style={{ width: '100%' }} className="width500px p-inputtext-sm block mb-2 " id="cognome" value={cognome} onChange={(e) => setCognome(e.target.value)} />

                                        </div>
                                    </div>
                                    <div className='formgroup-inline col-12'>
                                        <div className='col-2 pj-bg-primary-light'>
                                            {getText("NOME")}
                                        </div>
                                        <div className='col-10'>
                                            <InputText style={{ width: '100%' }} className="width500px p-inputtext-sm block mb-2 " id="nome" value={nome} onChange={(e) => setNome(e.target.value)} />

                                        </div>
                                    </div>
                                </>

                            }

                            {codice_persona != null &&
                                <div className='formgroup-inline col-12'>
                                    <div className='col-2 pj-bg-primary-light'>
                                        {getText("PERSONAL_CODE")}
                                    </div>
                                    <div className='col-10'>
                                        {codice_persona}
                                    </div>
                                </div>

                            }

                            <div className='formgroup-inline col-12'>
                                <div className='col-2 pj-bg-primary-light'>
                                    {getText("OGGETTO")}
                                </div>
                                <div className='col-10'>
                                    <InputText style={{ width: '100%' }} placeholder={getText("SCRIVI_QUALCOSA")} className="width500px p-inputtext-sm block mb-2 " id="name" value={oggetto} onChange={(e) => setOggetto(e.target.value)} />
                                </div>
                            </div>
                            <div className='formgroup-inline col-12'>
                                <div className='col-2 pj-bg-primary-light'>
                                    {getText("TESTO")}
                                </div>
                                <div className='col-10'>
                                    <InputTextarea placeholder={getText("SCRIVI_QUALCOSA")} rows={5} cols={100} className="width500px p-inputtext-sm block mb-2 " id="name" value={testo} onChange={(e) => setTesto(e.target.value)} />
                                </div>
                            </div>
                            <div className='formgroup-inline col-12'>
                                <div className='col-2 pj-bg-primary-light'>
                                    {getText("SEND_TO")}
                                </div>
                                <div className='col-10'>
                                    {dests.length === 1 ?
                                        <> {getText(dests[0].label)} </> :
                                        <Dropdown valueTemplate={queueTemplate} itemTemplate={queueTemplate} value={selectedQueue} options={dests} onChange={(e) => setSelectedQueue(e.value)} optionLabel="label" placeholder={getText("SELECT_A_VALUE")} />
                                    }
                                </div>
                            </div>
                            <div className='formgroup-inline col-12'>
                                <div className='col-2 pj-bg-primary-light'>
                                    {getText("ATTACHMENTS")}
                                </div>
                                <div className='col-10'>
                                    <FileUpload disabled={ticketSent} ref={allegatoRef} mode="basic" customUpload uploadHandler={allegatoBase64Uploader} name="demo[]" accept="*" maxFileSize={10000000} />
                                    <div className='col-12'>
                                        {allegato != null &&
                                            <>
                                                {allegato.map((file, index) => (
                                                    <div key={index}>
                                                        {file.name} ({file.size} bytes)
                                                    </div>
                                                ))}
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>


                            <div className='formgroup-inline col-12'>
                                <PJButton label={getText("INVIA_TICKET")} disabled={!validForm() || ticketSent} onClick={() => sendTicket()}></PJButton>
                                {ticketSent &&
                                    <PJButton className="ml-2" label={getText("NUOVA_RICHIESTA")} onClick={() => createNewTicket()}></PJButton>
                                }
                            </div>
                        </>


                    </PJContent>
                </PJPage>
            }


        </>
    )
}

export default DottorandiForm
